<template>
  <div>
    <template v-if="loading">
      <div class="text-xs-center" style="padding: 10px 0px">
        <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
      </div>
    </template>
    <template v-else>
      <v-layout wrap>
        <v-flex xs12 sm6
          ><h2 class="headline ma-0">{{ title }}</h2></v-flex
        >
        <v-flex class="form-control" xs12 sm6>
          <input
            v-model="search"
            type="text"
            placeholder="ค้นหาชื่อหรือหมายเลขบรอดแคสต์"
            @keydown.enter="onSearch"
            @input="onSearch"
          />
        </v-flex>
      </v-layout>

      <div class="broadcasts mt-3">
        <template v-if="broadcastList && broadcastList.length > 0">
          <div
            v-for="(broadcast, index) in broadcastList"
            :key="`${status}_broadcast_${index}`"
            class="broadcast mb-3"
          >
            <template v-if="status === 'draft'">
              <broadcast-item
                :broadcast="broadcast"
                :index="index"
                :draft="true"
                @editBroadcast="handleEditBroadcast"
                @copyBroadcast="handleCopyBroadcast"
                @deleteBroadcast="handleDeleteBroadcast"
              ></broadcast-item>
            </template>
            <template v-else-if="status === 'broadcasted'">
              <broadcast-item
                :broadcast="broadcast"
                :index="index"
                :draft="false"
                @editBroadcast="handleEditBroadcast"
                @copyBroadcast="handleCopyBroadcast"
                @viewBroadcast="handleViewBroadcast($event)"
                @onShowBroadcastHistory="
                  handleShowBroadcastHistory({ type: $event, broadcast: broadcast })
                "
              ></broadcast-item>
            </template>
            <template v-else-if="status === 'approval'">
              <broadcast-item
                :broadcast="broadcast"
                :index="index"
                :draft="true"
                :is-save-only="true"
                :is-waiting-approval="true"
                @editBroadcast="handleEditBroadcast"
                @viewBroadcast="handleViewBroadcast($event)"
                @onShowBroadcastHistory="
                  handleShowBroadcastHistory({ type: $event, broadcast: broadcast })
                "
              ></broadcast-item>
            </template>
            <template v-else-if="status === 'waiting'">
              <broadcast-item
                :broadcast="broadcast"
                :index="index"
                :draft="false"
                :is-approver="true"
                :is-waiting-approval="true"
                @viewBroadcast="handleViewBroadcast($event)"
              ></broadcast-item>
            </template>
            <template v-else-if="status === 'approved'">
              <broadcast-item
                :broadcast="broadcast"
                :index="index"
                :draft="false"
                :is-approver="true"
                @viewBroadcast="handleViewBroadcast($event)"
                @onShowBroadcastHistory="
                  handleShowBroadcastHistory({ type: $event, broadcast: broadcast })
                "
              ></broadcast-item>
            </template>
          </div>
          <div class="text-xs-center">
            <v-pagination
              v-model="currentPage"
              :length="pageLength"
              :total-visible="7"
              @input="handleChangePage($event)"
            ></v-pagination>
          </div>
        </template>
        <template v-else>
          <p class="no-broadcast text-xs-center">{{ $t('No Sent broadcast') }}</p>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import mainAiraApi from '@/api/aira.js'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { handleResponse, handleApiError } from '@/api/util'
import BroadcastItem from './BroadcastItem.vue'

export default {
  components: {
    ScaleLoader,
    BroadcastItem
  },
  props: ['status', 'title'],
  data() {
    return {
      loading: false,
      broadcastList: [],
      offset: 0,
      limit: 5,
      search: '',
      updateSearchTimeout: null,
      currentPage: 1,
      pageTemp: 1,
      pageTotal: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.pageTotal) {
        return Math.ceil(this.pageTotal / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    if (this.status) {
      this.loading = true
      await this.handleFetchBroadcastByStatus(this.status)
      this.loading = false
    }
  },
  methods: {
    handleShowBroadcastHistory(payload) {
      this.$emit('onShowBroadcastHistory', payload)
    },
    async handleFetchBroadcastByStatus(status) {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          status,
          limit: vm.limit,
          offset: vm.offset
        }

        if (vm.search) {
          Object.assign(data, { search: vm.search })
        }

        vm.$store.dispatch('loading')
        const response = await vm.getBroadcast(data)
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.data) {
          let responseData = null
          const tempData = response.data.data
          if (vm.status === 'draft') {
            responseData = tempData.filter((item) => item.status === 'draft')
          } else {
            responseData = tempData
          }

          if (responseData) {
            vm.pageTotal = parseInt(response.data.total)
            vm.broadcastList.length = 0
            vm.broadcastList = responseData
          }
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async getBroadcast(payload) {
      try {
        const response = await mainAiraApi.getBroadcast({ config: payload })
        handleResponse(response)

        if (response && response.status === 200) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        return null
      }
    },
    async handleDeleteBroadcast(broadcastId, broadcastName) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: vm.$t('Do you want to delete {name}?', {
            // eslint-disable-next-line no-useless-escape
            name: broadcastName.replace(/\<|\>/g, '')
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.deleteBroadcast(broadcastId)
          vm.$store.commit('CLEAR_LOADING')

          if (response && response.status === 200) {
            vm.broadcastList.map((broadcast, index) => {
              if (broadcast.id == broadcastId) {
                vm.broadcastList.splice(index, 1)
                return false
              }
            })
          }
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async deleteBroadcast(id) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await mainAiraApi.deleteBroadcast({ pageId: vm.selectedBot.pageid, id })
        vm.$store.commit('CLEAR_LOADING')
        handleResponse(response)

        if (response && response.status === 200) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
        return null
      }
    },
    handleChangePage(page) {
      const vm = this
      if (vm.pageTemp !== page) {
        vm.pageTemp = page
        vm.offset = vm.pageTemp * vm.limit - vm.limit
      }
      vm.handleFetchBroadcastByStatus(vm.status)
    },
    handleViewBroadcast(index) {
      const broadcast = this.broadcastList[index]
      this.$emit('viewBroadcast', broadcast)
    },
    handleEditBroadcast(broadcast) {
      this.$emit('editBroadcast', broadcast)
    },
    async handleCopyBroadcast(payload) {
      const vm = this
      try {
        let data = null

        if (payload == null) return false
        const broadcast = vm.broadcastList.find((el) => {
          return el.id == payload.id
        })
        if (broadcast) {
          data = Object.assign({}, broadcast)
        }

        if (Object.keys(data).length > 0) {
          const result = await vm.$swal.fire({
            title: vm.$t('Do you want to copy {name}?', { name: data.name.replace(/\<|\>/g, '') }),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })

          if (result.value) {
            vm.$emit('copyBroadcast', data)
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    onSearch() {
      const vm = this
      if (vm.updateSearchTimeout) {
        clearTimeout(vm.updateSearchTimeout)
      }

      if (vm.loading) return false
      vm.updateSearchTimeout = setTimeout(async () => {
        vm.loading = true
        try {
          vm.pageTemp = 1
          vm.currentPage = 1
          vm.offset = 0
          vm.handleFetchBroadcastByStatus(vm.status)
        } catch (error) {
          vm.loading = false
          console.error(error)
        }
        vm.loading = false
        vm.updateSearchTimeout = null
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Aira/Broadcast/BroadcastGroup.vue